import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import AppPage from "../../design-system/components/AppPage";
import AppTabs from "../../design-system/components/AppTabs";
import AppWorkspace from "../../design-system/components/AppWorkspace";
import FeatureSetupPanel from "./FeatureSetupPanel";
import { ROWS_APP, ROWS_SPECIAL, ROWS_WEB } from "./rows";

const TAB_DEFINITIONS = [
  { key: "web", labelKey: "feature_setup.tabs.web", endpoint: "/api/web/feature-setup/web", rows: ROWS_WEB },
  { key: "app", labelKey: "feature_setup.tabs.app", endpoint: "/api/web/feature-setup/app", rows: ROWS_APP },
  { key: "special", labelKey: "feature_setup.tabs.special", endpoint: "/api/web/feature-setup/special", rows: ROWS_SPECIAL },
];

export default function FeatureSetupIndex() {
  const { t } = useTranslation();
  const [tab, setTab] = useState("web");
  const tabs = useMemo(
    () => TAB_DEFINITIONS.map((item) => ({ ...item, label: t(item.labelKey) })),
    [t]
  );
  const active = tabs.find((item) => item.key === tab) || tabs[0];

  return (
    <AppPage>
      <AppWorkspace title={t("feature_setup.title")}>
        <AppTabs
          items={tabs}
          activeKey={tab}
          onChange={setTab}
          aria-label={t("feature_setup.tabs.aria")}
        />
        <FeatureSetupPanel
          tabKey={active.key}
          title={active.label}
          endpoint={active.endpoint}
          defaultRows={active.rows}
        />
      </AppWorkspace>
    </AppPage>
  );
}
